import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isProductBundle as isProductBundleUtil } from 'commerce-products-lib/utils/subject';
import { Button } from 'foundations-components/transitional/components/Button';
import { useCloneProductById } from 'products-ui-components/hooks/useCloneProductById';
import { useCloneProductAction } from '../../contexts/CloneProductActionContext';
import { usePermissionsContext } from '../../contexts/PermissionsContext';
import { useProductData } from '../../contexts/ProductDataContext';
import { useProductId } from '../../contexts/ProductIdContext';
import { jsx as _jsx } from "react/jsx-runtime";
const onError = err => {
  Raven.captureException(err);
};
export function ProductHighlightCloneButton() {
  const productId = useProductId();
  const {
    product: productData
  } = useProductData();
  const cloneProduct = useCloneProductAction();
  const {
    hasScope
  } = usePermissionsContext();
  const {
    handleClone,
    isLoading
  } = useCloneProductById({
    objectId: productId,
    onClone: cloneProduct,
    onError
  });
  const hasProductEditScope = hasScope('inbounddb-product-library-write');
  const isProductBundle = !!productData && isProductBundleUtil(productData);
  if (!productId || !hasProductEditScope || isProductBundle) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    onClick: handleClone,
    "data-test-id": "clone-product-button",
    disabled: isLoading,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actions.clone"
    })
  });
}